export const AUTHORIZATION_PASS = 'AuthorizationPass';
export const AUTHORIZATION_BYPASS = 'AuthorizationBypass';
export const SEND_AUTHORIZATION_REQUEST = 'SendAuthorizationRequest';

export const CHOICE_MY_ACCOUNT = 'MyAccount';
export const CHOICE_SIGNATURE_PAGE = 'SignaturePage';

export const isAuthorizationPassed = (authorizationType) => authorizationType === AUTHORIZATION_PASS;
export const isAuthorizationBypassed = (authorizationType) => authorizationType === AUTHORIZATION_BYPASS;
export const hasSentAuthorizationRequest = (authorizationType) => authorizationType === SEND_AUTHORIZATION_REQUEST;

export const isChoiceMyAccount = (choice) => choice === CHOICE_MY_ACCOUNT;
export const isChoiceSignaturePage = (choice) => choice === CHOICE_SIGNATURE_PAGE;

export const isAuthorizationCompleted = (authorizationInfo) => { 
    if(!authorizationInfo) {
        return false;
    }

    if (isAuthorizationPassed(authorizationInfo.authorizationType)) {
        return true;
    }

    if (isAuthorizationBypassed(authorizationInfo.authorizationType)) {
        return true;
    }

    if(isChoiceMyAccount(authorizationInfo.choice) && authorizationInfo.choiceTimestamp !== null
                                                   && authorizationInfo.hasMessagedClient
                                                   && authorizationInfo.messageTimestamp !== null
                                                   && authorizationInfo.hasClientCompletedAuthorization) {
        return true;
    }

    if(isChoiceSignaturePage(authorizationInfo.choice) && authorizationInfo.choiceTimestamp !== null
                                                       && authorizationInfo.signaturePage !== null
                                                       && authorizationInfo.signaturePageUploadTimestamp !== null
                                                       && authorizationInfo.hasSubmittedSignaturePageToRac) {
        return true;
    }

    return false;
}

export const cleanAuthorizationInfo = (authorizationInfo) => {
    if(!authorizationInfo) return;

    if(isAuthorizationPassed(authorizationInfo.authorizationType) || isAuthorizationBypassed(authorizationInfo.authorizationType)) {
        authorizationInfo.choice = null;
        authorizationInfo.choiceTimestamp = null;
        authorizationInfo.hasMessagedClient = false;
        authorizationInfo.messageTimestamp = null;
        authorizationInfo.hasClientCompletedAuthorization = false;
        authorizationInfo.signaturePage = null;
        authorizationInfo.signaturePageUploadTimestamp = null;
        authorizationInfo.hasSubmittedSignaturePageToRac = false;
    }
    else if(isChoiceMyAccount(authorizationInfo.choice)) {
        authorizationInfo.signaturePage = null;
        authorizationInfo.signaturePageUploadTimestamp = null;
        authorizationInfo.hasSubmittedSignaturePageToRac = false;
    }
    else if(isChoiceSignaturePage(authorizationInfo.choice)) {
        authorizationInfo.hasMessagedClient = false;
        authorizationInfo.messageTimestamp = null;
        authorizationInfo.hasClientCompletedAuthorization = false;
    }
};

export const getRacExpiryDate = (authorizationInfo) => {
    if(!authorizationInfo?.choiceTimestamp) return null;

    const authorizationChoiceTime = new Date(authorizationInfo.choiceTimestamp).getTime();
    const expiryTime = 10 * 24 * 60 * 60 * 1000;
    const expiryDate = new Date(authorizationChoiceTime + expiryTime);

    return expiryDate.toISOString();
};

